import { z } from "zod/v4";

const LogoResponseSchema = z.object({
  logo: z.string().optional(),
  s3Url: z.string().optional(),
});

type LogoResponse = z.infer<typeof LogoResponseSchema>;

export { LogoResponseSchema };
export type { LogoResponse };
